import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { VerificationCall } from 'src/app/models/ApplicantDataResponses/ApplicantDataResponses';
import { FilteringService } from 'src/app/services/filtering.service';
import { SearchPackageService } from 'src/app/services/search-package.service';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-verification-call',
  templateUrl: './verification-call.component.html',
  styleUrls: ['./verification-call.component.less']
})
export class VerificationCallComponent implements OnInit {
  @Input() callAttempts : VerificationCall[];
  @Input() responseId : number;
  @Input() isResVer : boolean;
  newCall : VerificationCall = new VerificationCall();
  constructor(public filtering : FilteringService, 
    public searches : SearchPackageService,
    public appData : ApplicantDataService,
    public toasts : ToastrService) { }

  ngOnInit() {
  }

  saveCallAttempt(){
    this.newCall.ResponseId = this.responseId;
    this.appData.SaveVerificationCallAttempt(this.newCall,this.isResVer).subscribe(
      (rsp: VerificationCall)=>{
        if(!this.callAttempts) this.callAttempts = [];
        this.callAttempts.push(rsp);
        this.callAttempts = this.callAttempts.sort((n1,n2)=>{ 
           if(n1.callDate < n2.callDate) return 1;
           if(n1.callDate > n2.callDate) return -1;
           return 0;
          });
          this.newCall = new VerificationCall();
      },
    (err:any)=>{
      this.toasts.error(JSON.stringify(err))

    })
  }

}
